import ArkLoader from '@src/js/common/ark-extensions';
import { tdw } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/tdw-report';
import eventBus, { EventKeys } from '@src/slide/infrastructure/module/independent/event-emitter/instance';

// 理想情况 vip 相关信息应该从 ark 获取；当下没有合适的事件，先用这个凑合
const waitForUserInfo = () => Promise.race([
    new Promise((resolve) => {
        eventBus.on(EventKeys.LOGIN_USER_INFO_READY_EVENT, resolve);
    }),
    new Promise((resolve) => {
        setTimeout(resolve, 10 * 1000);
    }),
]);
const waitForUserInfoPromise = waitForUserInfo();

/** AI 创建文档曝光 */
export const reportExposure = async () => {
    if (!isCreateByAI()) return;

    await waitForUserInfoPromise;
    tdw({
        opername: 'doc_ai',
        module: 'file_page',
        action: 'show',
        ver5: getVipType(),
        ver7: 'ai',
        ver9: 'slide',
    });
};

/** AI 创建文档编辑行为 */
export const reportEdit = async () => {
    if (!isCreateByAI()) return;

    await waitForUserInfoPromise;
    tdw({
        opername: 'doc_ai',
        module: 'file_page',
        action: 'click',
        ver5: getVipType(),
        ver7: 'ai',
        ver9: 'slide',
    });
};

/** AI 创建文档导出 */
export const reportExport = async () => {
    if (!isCreateByAI()) return;

    await waitForUserInfoPromise;
    tdw({
        opername: 'doc_ai',
        module: 'file_page',
        action: 'output',
        ver5: getVipType(),
        ver7: 'ai',
        ver9: 'slide',
    });
};

/** AI 移动端入口点击 */
export const reportAIEntranceClick = async () => {
    await waitForUserInfoPromise;
    tdw({
        opername: 'doc_ai',
        module: 'entrance_btn',
        action: 'click',
        ver5: getVipType(),
        ver7: 'mobile_topbutton',
        ver9: 'slide',
    });
};

function getVipType() {
    const vipInfo = ArkLoader.extensionService.dependentServiceCombinder?.accountApplication?.vipInfo;
    return vipInfo?.type;
}

function isCreateByAI(): boolean {
    return window.basicClientVars?.docInfo?.createSource === 10102;
}
